import { DialogContentText, DialogContent } from '@mui/material';
import { type FC, useCallback } from 'react';

import { useMutateDeleteEmergencyContact } from '../../api/emergency-contacts.api.js';
import { type EmergencyContact } from '../../models/index.js';
import { Events, track } from '../../utils/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface EmergencyContactDeleteProps {
  open: boolean;
  onClose: () => void;
  patientId?: string;
  contact?: EmergencyContact;
  refetch: () => void;
}
const EmergencyContactDelete: FC<EmergencyContactDeleteProps> = ({
  open,
  onClose,
  patientId,
  contact,
  refetch,
}) => {
  const deleteMutation = useMutateDeleteEmergencyContact();
  const onSubmit = useCallback(async () => {
    if (contact?.id) {
      return deleteMutation.mutateAsync(contact.id);
    }
  }, [contact, deleteMutation]);

  const trackFn = useCallback(() => {
    track(Events.EmergencyContactDelete, {
      emergencyContactId: contact?.id,
      patientId,
    });
  }, [contact, patientId]);

  return (
    <DeleteDialog
      open={open}
      name={'emergency-contact'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
      trackFn={trackFn}
    >
      {contact ? (
        <DialogContent>
          <DialogContentText id="emergency-contact-alert-dialog-description">
            {contact.firstName} {contact.lastName} / {contact.phoneNumber}
            {`${contact?.relationship ? ' / ' + contact.relationship : ''}`}
          </DialogContentText>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default EmergencyContactDelete;
